import axios from "axios";
import { Env } from "../enviroment/environment";
import authHeader from "./auth-header";

const API_URL = Env.AdminDashboardApiUrl;

// Reads live issuer balances for every card in the uploaded sheet.
// timeout: 0 disables the client-side abort - a large sheet legitimately runs for
// minutes and the server enforces its own time guard, returning partial results.
const ViewCardBalance = (formData) => {
  return axios
    .post(API_URL + "viewcardbalance", formData, {
      headers: authHeader(),
      timeout: 0,
    })
    .then((response) => {
      return response;
    });
};

const adminDashboardService = {
  ViewCardBalance,
};

export default adminDashboardService;
